import { pagesLinks } from "../common/links"

export default {
	header: "Партнёрская программа Quick Resto",
	subtitle: "Новые возможности для вашего бизнеса",
	buttonText: "Оставить заявку",
	link: pagesLinks.partners.signUp.href,
	alt: "Партнёрская программа Quick Resto - фотография 1",
}
